import { Component, OnInit } from '@angular/core';
import { SidenavService } from '../../services/sidenav/sidenav.service';
import { Router } from '@angular/router';
import { CVA_CONSTANTS } from '../../util/constants';
import { ROUTE_CONSTANTS } from '../../util/route.constants';
import { PatientSearchModalComponent } from '../patient-search-modal/patient-search-modal.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
    standalone: false,
    selector: 'cva-bottom-nav',
    templateUrl: './bottom-nav.component.html',
    styleUrl: './bottom-nav.component.scss',
    
})
export class BottomNavComponent implements OnInit {
  ROUTE_CONSTANTS = ROUTE_CONSTANTS;
  appScopes: {
    icon: string;
    title: string;
    route: string;
  }[] = CVA_CONSTANTS.NAVIGATION_BUTTONS;

  activeRoute: string | undefined;

  isSideNavEnabled: boolean = false;

  constructor(private readonly sidenavService: SidenavService,
    public readonly router: Router, private readonly dialog: MatDialog,) {
    this.activeRoute = this.appScopes[0].route;
  }

  ngOnInit(): void {
    this.activeRoute = this.appScopes[0].route;
    this.getSideNavStatus();
  }

  getSideNavStatus() {
    this.sidenavService
      .getRouterObservable()
      .subscribe(
        (sideNavInfo: { open: boolean; props: { route: string } | null }) => {
          this.isSideNavEnabled = sideNavInfo.open;
          this.activeRoute = sideNavInfo?.props?.route;

          // const historicalDataNavItemIndex = this.appScopes.findIndex(
          //   (item) => item.title === 'Historical Data'
          // );

          // if (sideNavInfo.props?.route?.endsWith(ROUTE_CONSTANTS.CONSULTATION)) {
          //   if (historicalDataNavItemIndex === -1) {
          //     this.appScopes.push({
          //       icon: 'menu',
          //       title: 'Historical Data',
          //       route: '',
          //     });
          //   }
          // } else if (historicalDataNavItemIndex !== -1) {
          //   this.appScopes.splice(historicalDataNavItemIndex, 1);
          // }
        }
      );
  }

  onSelectTab(event: MouseEvent,
    scope: {
      icon: string;
      title: string;
      route: string;
    } | null
  ) {
    event.preventDefault()
    if (scope?.route) {
      if (scope.title == 'Patient Search') {
        this.dialog.open(PatientSearchModalComponent, {
          panelClass: 'custom-modalbox',
          width: '90vw',
          position: {
            top: '6vw'
          }
        });
        return;
      }
      this.activeRoute = scope.route;
      this.router.navigate([scope.route]);
    }
  }
}
